import { TYPES } from '../actions/cartAction'

export const receiptInitialState = {
    data: []
}

export function receiptReducer(state, action) {
    switch (action.type) {
        case TYPES.ADD_TO_CART: {
            return {
                ...state,
                data: [...state.data, {...action.payload} ]
            }
        }
        case TYPES.REMOVE_ONE_FROM_CART: {
            return {
                ...state,
                data: state.data.filter(obj => obj.paymentMethod !== action.payload)
            }
        }
        case TYPES.CLEAR_CART: {
            return receiptInitialState
        }
        default:
            return state
    }
}